<template>
  <b-row>
    <b-col>
      <b-card>
        <template v-slot:header>
          <b-row class="mt-1">
            <b-col class="text-right">
              <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
              <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.agreements_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="agreements_search_collapse" class="mt-2 mb-2">
                <AgreementFiltering ref="agreementsFiltering" v-if="displayFilters" @filterAgreements="filterAgreements($event)" :filters="filters" :filterReference="filtersReference"></AgreementFiltering>
              </b-collapse>
            </b-col>
          </b-row>
        </template>
        <div class="bcard-body">
          <div v-if="isLoadingAgreements">
            <Loader></Loader>
          </div>
          <div v-else-if="getAgreements.length < 1 && !isLoadingAgreements">
            {{ $t('views.agreements.list.noAgreements') }}
          </div>
          <table class="table table-sm table-striped table-hover text-center" v-else>
            <thead>
            <tr>
              <th style="width: 5%"></th>
              <th style="width: 10%">{{ $t('views.agreements.list.dateFrom') }}</th>
              <th style="width: 15%">{{ $t('views.agreements.list.agreementNumber') }}</th>
              <th style="width: 15%">{{ $t('menu.tags.list') }}</th>
              <th style="width: 15%">{{ $t('views.exsbitems.list.title') }}</th>
              <th style="width: 15%">{{ $t('views.agreements.list.status') }}</th>
              <th style="width: 30%">{{ $t('views.agreements.list.userData') }}</th>
              <th style="width: 25%">{{ $t('views.agreements.form.monthlyInvoice') }}</th>
              <th style="width: 5%"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in getAgreements" :key="item['@id']">
              <td class="text-center">
                <b-form-checkbox
                  v-model="selectedItems"
                  v-if="item.decisionUser == 0"
                  :id="'checkbox_'+index"
                  :value="getIdLink(item['@id'])"
                ></b-form-checkbox>
              </td>
              <td>
                {{ item.dateFrom ? $moment(item.dateFrom).format('YYYY-MM-DD') : ' - ' }}
              </td>
              <td>
                <router-link :to="{ name: 'EXABAgreementShow', params: { id: item['@id'] } }">
                  {{ item.number || $t('views.agreements.list.noNumber') }}
                </router-link>
                <div>
                  <b-badge v-if="item.applicationName"> {{ item.applicationName }} </b-badge>
                </div>
              </td>
              <td>
                <span v-for="tag in item.agreementTags" :key="tag['@id']">
                  <b-badge class="mr-2 mb-2 organizationleadtag" pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
                </span>
              </td>
              <td>
                <p v-for="(agreementItem, agreementItemIndex) in item.agreementItems" :key="agreementItemIndex" class="m-0 p-0">
                  <span v-if="agreementItem.item">
                    {{ agreementItem.item.name }}
                  </span>
                  <span v-else-if="agreementItem.priceGroup">
                    {{ agreementItem.priceGroup.name }}
                  </span>
                </p>
              </td>
              <td>
                <div>
                  {{ $t(getAgreementStatuses[item.status]) }}
                </div>
                <div>
                  <b-badge v-if="item.decisionUser == 0"> {{ $t('views.agreements.list.decisionUser.offer') }} </b-badge>
                  <b-badge variant="primary" v-else-if="item.status == 1"> {{ $t('views.agreements.list.decisionUser.waiting') }} </b-badge>
                  <b-badge variant="warning" v-else-if="item.decisionUser == 2"> {{ $t('views.agreements.list.decisionUser.rejected') }} </b-badge>
                  <b-badge variant="success" v-else-if="item.decisionUser == 3 && item.status == 3">
                    {{ $t('views.agreements.list.decisionUser.accepted') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')}}
                  </b-badge>
                  <b-badge variant="success" v-else-if="item.decisionUser == 5 && item.status == 3">
                    {{ $t('views.agreements.list.decisionUser.signed') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')}}
                  </b-badge>
                  <br v-if="item.currentStatus || item.currentStatus === 0">
                  <b-badge v-if="item.currentStatus === 0">{{ $t('views.agreements.list.currentStatuses.notOpened') }}</b-badge>
                  <b-badge v-if="item.currentStatus === 1">{{ $t('views.agreements.list.currentStatuses.opened')  +  ' - ' + $moment(item.lastActivityDate).format('YYYY-MM-DD HH:mm') }}</b-badge>
                  <b-badge v-if="item.currentStatus === 2">{{ $t('views.agreements.list.currentStatuses.currentStep')  +  ' - ' + item.currentStep + ' - ' + $moment(item.lastActivityDate).format('YYYY-MM-DD HH:mm') }}</b-badge>
                  <b-badge v-if="item.currentStatus === 3">{{ $t('views.agreements.list.currentStatuses.agreementSaved')  +  ' - ' + $moment(item.lastActivityDate).format('YYYY-MM-DD HH:mm') }}</b-badge>
                  <b-badge v-if="item.currentStatus === 4">{{ $t('views.agreements.list.currentStatuses.smsCodeSent')  +  ' - ' + $moment(item.lastActivityDate).format('YYYY-MM-DD HH:mm') }}</b-badge>
                  <b-badge v-if="item.currentStatus === 5">{{ $t('views.agreements.list.currentStatuses.signedBySmsCode')  +  ' - ' + $moment(item.lastActivityDate).format('YYYY-MM-DD HH:mm') }}</b-badge>
                </div>
              </td>
              <td>
                <router-link v-if="item.idClient.isCompany === 0" :to="{name: 'ContractorShow', params: { id: item.idClient['@id'] }}">
                  {{ item.idClient.firmname1 === '' ? item.idClient.fullName : item.idClient.firmname1 }}
                </router-link>
                <router-link v-else :to="{name: 'FirmShow', params: { id: item.idClient['@id'] }}">
                  {{ item.idClient.firmname1 === '' ? item.idClient.fullName : item.idClient.firmname1 }}
                </router-link>
              </td>
              <td>
                <b-form-checkbox
                  :disabled="userRoles.includes('ROLE_CLIENT')"
                  style="display:inline-block"
                  :id="'monthlyInvoiceCheckbox' + item['@id']"
                  v-model="item.monthlyInvoice"
                  :value="1"
                  @input="updateMonthlyInvoice(item)"
                  :unchecked-value="0">
                </b-form-checkbox>
                <span style="display: inline-block">{{$t("views.agreements.form.autoInvoicing")}}</span>
              </td>
              <td v-if="userRoles.includes('ROLE_CLIENT') && (item.decisionUser == 1 || item.decisionUser == 3 || item.decisionUser == 4)">
                <button type="button" class="btn btn-success" @click="showAgreementPreviewHTMLModal(item['@id'])">
                  {{ $t('buttons.agreementPreview') }}
                </button>
              </td>
              <td v-else-if="userRoles.includes('ROLE_SUPER_USER') || userRoles.includes('ROLE_OWNER')">
                <b-dropdown variant="link" size="sm" right text="Right align">
                  <template #button-content>
                    <i class="fa fa-bars fa-lg"></i>
                  </template>
                  <b-dropdown-item @click="showAgreement(item['@id'])"><i class="fa fa-eye mr-2"></i>{{$t('buttons.preview')}}</b-dropdown-item>
                  <b-dropdown-item @click="editAgreement(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.status == 5" @click="confirmAgreementSigning(item)"><i class="fa fa-check mr-2"></i>{{$t('views.agreements.list.options.confirmAgreementSigning')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.type === 1" @click="sendOfferToAccept(item['@id'])"><i class="fa fa-file-check mr-2"></i>{{$t('views.agreements.list.options.sendOfferToAccept')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.type === 1" @click="sendEmailProposition(item['@id'])"><i class="fa fa-file-check mr-2"></i>{{$t('views.agreements.list.options.sendEmailProposition')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.type === 1" @click="showAgreementPreviewHTMLModal(item['@id'])"><i class="fa fa-file-check mr-2"></i>{{$t('views.agreements.show.decisionClient')}}</b-dropdown-item>
<!--                  <b-dropdown-item v-if="item.type === 1"><i class="fa fa-file-times mr-2"></i>{{$t('views.agreements.list.options.rejectOffer')}}</b-dropdown-item>-->
<!--                  <b-dropdown-item v-if="false" ><i class="fa fa-file-alt mr-2"></i>{{$t('views.agreements.list.options.acceptWithCommentOffer')}}</b-dropdown-item>-->
                </b-dropdown>
              </td>
              <td v-else> </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination :view="view" :totalItems="totalItems" @getPageNumber="getPage($event.page, $event.itemsPerPage)"></Pagination>
      </b-card>
      <b-dropdown :disabled="selectedItems.length === 0" size="sm" variant="warning" dropright text="Drop-Right">
        <template #button-content>
          {{ $t('buttons.collectionOperations') }}
        </template>
        <b-dropdown-item @click="sendMultipleEmailProposition()"><i class="fa fa-file-check mr-2"></i>{{$t('views.agreements.list.options.sendOfferToAcceptCollection')}}</b-dropdown-item>
        <b-dropdown-item @click="massEditAgreements()"><i class="fa fa-edit mr-2"></i>{{$t('views.agreements.list.options.massEditAgreements')}}</b-dropdown-item>
        <b-dropdown-item @click="createAgreementItems()"><i class="fa fa-plus mr-2"></i>{{$t('views.agreements.list.options.createAgreementItems')}}</b-dropdown-item>
        <b-dropdown-item @click="createAgreementAdditionalItems()"><i class="fa fa-plus mr-2"></i>{{$t('views.agreements.list.options.createAgreementAdditionalItems')}}</b-dropdown-item>
        <b-dropdown-item @click="generateInvoicesFromAgreements()"><i class="fa fa-plus mr-2"></i>{{$t('views.agreements.list.options.generateInvoicesFromAgreementsSelected')}}</b-dropdown-item>
      </b-dropdown>
      <button :disabled="selectedItems.length > 0" type="button" class="btn btn-sm" @click="generateInvoicesFromAgreements()"> <i class="mr-1 fa fa-file"></i> {{$t('views.agreements.list.options.generateInvoicesFromAgreements')}}</button>
      <button :disabled="selectedItems.length > 0" type="button" class="btn btn-sm" @click="updateDebtInfoInAgreements()"> <i class="mr-1 fa fa-file"></i> {{$t('views.agreements.list.options.updateDebtInfoInAgreements')}}</button>
<!--      <b-dropdown-item @click="createAgreementAdditionalItems()"><i class="fa fa-plus mr-2"></i>{{$t('views.agreements.list.options.createAgreementAdditionalItems')}}</b-dropdown-item>-->
      <SendOfferToAcceptModal></SendOfferToAcceptModal>
      <AgreementPreviewHTMLModal :agreement-list="getAgreements"></AgreementPreviewHTMLModal>
      <AgreementAcceptModal></AgreementAcceptModal>
      <SendEmailPropositionModal
        @reset="resetSelectedItems()"
        :id="selectedItem"
        :id-collection="selectedItems">
      </SendEmailPropositionModal>
      <CreateAgreementItemsModal
        @reset="resetSelectedItems()"
        :id="selectedItem"
        :id-collection="selectedItems">
      </CreateAgreementItemsModal>
      <CreateAgreementAdditionalItemsModal
        @reset="resetSelectedItems()"
        :id="selectedItem"
        :id-collection="selectedItems">
      </CreateAgreementAdditionalItemsModal>
      <GenerateInvoicesFromAgreementModal :id-collection="selectedItems"></GenerateInvoicesFromAgreementModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AgreementFiltering from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/AgreementFiltering'
import Loader from '@/components/Dashboard/Layout/Loader'
import SendOfferToAcceptModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/SendOfferToAcceptModal'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import AgreementPreviewHTMLModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementPreviewHTMLModal'
import AgreementAcceptModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementAcceptModal'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import SendEmailPropositionModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/SendEmailPropositionModal'
import getId from '@/utils/getIdFromLink'
import CreateAgreementItemsModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/CreateAgreementItemsModal'
import CreateAgreementAdditionalItemsModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/CreateAgreementAdditionalItemsModal'
import ApiService from '@/utils/ApiService'
import GenerateInvoicesFromAgreementModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/GenerateinvoicesFromAgreementModal'

export default {
  name: 'AgreementsList',
  components: {
    GenerateInvoicesFromAgreementModal,
    CreateAgreementAdditionalItemsModal,
    CreateAgreementItemsModal,
    SendEmailPropositionModal,
    AgreementFiltering,
    Loader,
    SendOfferToAcceptModal,
    AgreementPreviewHTMLModal,
    AgreementAcceptModal,
    Pagination
  },
  data () {
    return {
      filters: {},
      filtersReference: {},
      filtersInitialPage: 1,
      items: [],
      selectedItems: [],
      selectedItem: null,
      displayFilters: false
    }
  },
  created () {
    this.initializeFilters()
    this.getPage()
    if (!(this.getPaymentsModelOptions.length > 0)) {
      this.fetchPaymentsModelOptions()
    }
    this.channelAgreements = this.$store.state.Pusher.subscribe('registrationdata')
    this.channelAgreements.bind('registrationdata', data => {
      this.getPage()
    })
  },
  destroyed () {
    this.$store.state.Pusher.unsubscribe('registrationdata')
  },
  computed: {
    filterStatus () {
      return JSON.stringify(this.filters) !== JSON.stringify(this.filtersReference)
    },
    userRoles () {
      return getUserRoles().roles
    },
    ableToViewItem () {
      return checkPermission('warehouses', 'EXSBItemShow')
    },
    ...mapGetters({
      view: 'agreements/list/getAgreementsView',
      totalItems: 'agreements/list/getAgreementsTotalItems',
      getAgreements: 'agreements/list/getAgreements',
      getAgreementStatuses: 'agreements/list/getAgreementStatuses',
      getPaymentsModelOptions: 'agreements/list/getPaymentsModelOptions',
      getAgreementTypes: 'agreements/list/getAgreementTypes',
      isLoadingAgreements: 'agreements/list/getIsLoadingAgreements',
      isLoadingPaymentsModelOptions: 'agreements/list/getIsLoadingPaymentsModelOptions',
      emailPropositionSend: 'agreements/emailPropositionModal/response'
    })
  },
  watch: {
    emailPropositionSend () {
      this.fetchAgreements(this.getBaseParams())
    },
    '$route.name' () {
      this.initializeFilters()
      this.fetchAgreements(this.getBaseParams())
    }
  },
  methods: {
    clearFilters () {
      if (this.$refs.agreementsFiltering) {
        this.$refs.agreementsFiltering.clearFilters()
      }
    },
    initializeFilters () {
      if (this.$route.name === 'EXABAgreementsList') {
        if (Object.keys(this.$store.state.filters.agreementsFilter).length === 0) {
          this.$store.state.filters.agreementsFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsFilter
        this.filtersReference = this.$store.state.filters.agreementsFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListSigned') {
        if (Object.keys(this.$store.state.filters.agreementsSignedFilter).length === 0) {
          this.$store.state.filters.agreementsSignedFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsSignedFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsSignedFilter
        this.filtersReference = this.$store.state.filters.agreementsSignedFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsSignedFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListOffers') {
        if (Object.keys(this.$store.state.filters.agreementsOffersFilter).length === 0) {
          this.$store.state.filters.agreementsOffersFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsOffersFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsOffersFilter
        this.filtersReference = this.$store.state.filters.agreementsOffersFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsOffersFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListWaiting') {
        if (Object.keys(this.$store.state.filters.agreementsWaitingFilter).length === 0) {
          this.$store.state.filters.agreementsWaitingFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsWaitingFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsWaitingFilter
        this.filtersReference = this.$store.state.filters.agreementsWaitingFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsWaitingFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListAccepted') {
        if (Object.keys(this.$store.state.filters.agreementsAcceptedFilter).length === 0) {
          this.$store.state.filters.agreementsAcceptedFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsAcceptedFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsAcceptedFilter
        this.filtersReference = this.$store.state.filters.agreementsAcceptedFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsAcceptedFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListSignaturePending') {
        if (Object.keys(this.$store.state.filters.agreementsSignaturePendingFilter).length === 0) {
          this.$store.state.filters.agreementsSignaturePendingFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsSignaturePendingFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsSignaturePendingFilter
        this.filtersReference = this.$store.state.filters.agreementsSignaturePendingFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsSignaturePendingFilterCurrentPage
      } else if (this.$route.name === 'EXABAgreementsListRejected') {
        if (Object.keys(this.$store.state.filters.agreementsRejectedFilter).length === 0) {
          this.$store.state.filters.agreementsRejectedFilter = JSON.parse(JSON.stringify(this.$store.state.filters.agreementsRejectedFilterReference))
        }
        this.filters = this.$store.state.filters.agreementsRejectedFilter
        this.filtersReference = this.$store.state.filters.agreementsRejectedFilterReference
        this.filtersInitialPage = this.$store.state.filters.agreementsRejectedFilterCurrentPage
      }
      this.displayFilters = true
    },
    confirmAgreementSigning (item) {
      this.$Swal({
        title: this.$t('notifications.agreement.confirmSigningTitle'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(() => {
        this.putConfirmAgreementSigning(item['@id']).then(response => {
          if (response) {
            this.fetchAgreements(this.getBaseParams())
          }
        })
      })
    },
    putConfirmAgreementSigning (id) {
      return new ApiService(`${id}/confirm_agreement_signing`).put({})
    },
    resetSelectedItems () {
      this.selectedItems = []
      this.selectedItem = null
    },
    sendMultipleEmailProposition () {
      this.toggleSendEmailPropositionModal()
    },
    createAgreementItems () {
      this.toggleCreateAgreementItemsModal()
    },
    createAgreementAdditionalItems () {
      this.toggleCreateAgreementAdditionalItemsModal()
    },
    generateInvoicesFromAgreements () {
      this.toggleGenerateInvoicesFromAgreementsModal()
    },
    async updateDebtInfoInAgreements () {
      await new ApiService(`e_x_a_b_agreements/updatedebtinfoinagreements`).post({})
      this.getPage()
    },
    editAgreement (id) {
      this.$router.push({ name: 'EXABAgreementsUpdate', params: { id: id } })
    },
    getBaseParams (hideLoader = false) {
      let params = Object.assign({}, this.filters)
      params.hideLoader = hideLoader
      return params
    },
    filterAgreements (params) {
      this.filters = params
      this.getPage(1)
    },
    updatePageNumber (number) {
      this.filtersInitialPage = number
      if (this.$route.name === 'EXABAgreementsList') {
        this.$store.state.filters.agreementsFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListSigned') {
        this.$store.state.filters.agreementsSignedFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListOffers') {
        this.$store.state.filters.agreementsOffersFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListWaiting') {
        this.$store.state.filters.agreementsWaitingFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListAccepted') {
        this.$store.state.filters.agreementsAcceptedFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListSignaturePending') {
        this.$store.state.filters.agreementsSignaturePendingFilterCurrentPage = number
      } else if (this.$route.name === 'EXABAgreementsListRejected') {
        this.$store.state.filters.agreementsRejectedFilterCurrentPage = number
      }
    },
    getPage (number = this.filtersInitialPage, itemsPerPage = undefined) {
      this.updatePageNumber(number)
      let params = this.getBaseParams()
      // let params = {}
      params['_page'] = number
      params['itemsPerPage'] = itemsPerPage
      this.fetchAgreements(params)
    },
    getPaymentsModelTitle (id) {
      if (this.getPaymentsModelOptions) {
        // eslint-disable-next-line eqeqeq
        return this.getPaymentsModelOptions.find(model => model.id == id).title
      } return ''
    },
    showAgreement (id) {
      this.$router.push({ name: 'EXABAgreementShow', params: { id: id } })
    },
    sendOfferToAccept (id) {
      this.toggleSendOfferToAcceptModal()
      this.setSendOfferToAcceptId(id)
    },
    sendEmailProposition (id) {
      this.selectedItem = id
      this.toggleSendEmailPropositionModal()
    },
    showAgreementPreviewHTMLModal (id) {
      this.toggleAgreementPreviewHTMLModal()
      this.setAgreementId(id)
      this.fetchSignBySMSFlag(id)
      this.fetchAgreementAsPDF()
    },
    massEditAgreements () {
      let agreementsIds = this.selectedItems.map(entry => {
        return getId(entry)
      })
      this.$router.push({ name: 'EXABAgreementsMassEdit', params: { agreementsIds: agreementsIds } })
    },
    updateMonthlyInvoice (item) {
      const response = new ApiService(item['@id']).put({ monthlyInvoice: item.monthlyInvoice })
      if (response.status === 200) {
        this.getPage()
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapMutations({
      toggleSendOfferToAcceptModal: 'agreements/list/toggleSendOfferToAcceptModal',
      setSendOfferToAcceptId: 'agreements/list/setSendOfferToAcceptId',
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal',
      setAgreementId: 'agreements/previewModal/setAgreementId',
      toggleSendEmailPropositionModal: 'agreements/emailPropositionModal/toggleModal',
      setSendEmailPropositionId: 'agreements/list/setSendEmailPropositionId',
      toggleCreateAgreementItemsModal: 'agreements/createAgreementItemsModal/toggleModal',
      toggleCreateAgreementAdditionalItemsModal: 'agreements/createAgreementAdditionalItemsModal/toggleModal',
      toggleGenerateInvoicesFromAgreementsModal: 'agreements/generateInvoicesFromAgreementModal/toggleModal'
    }),
    ...mapActions({
      fetchAgreements: 'agreements/list/fetchAgreements',
      fetchPaymentsModelOptions: 'agreements/list/fetchPaymentsModelOptions',
      fetchAgreementAsPDF: 'agreements/previewModal/fetchAgreementAsPDF',
      fetchSignBySMSFlag: 'agreements/acceptModal/fetchSignBySMSFlag'
    })
  }
}
</script>
